import { Author } from '@/types/models.types';

interface AuthorBioProps {
  author: Author;
}

const AuthorBio = ({ author }: AuthorBioProps) => {
  return (
    <>
      <div className='py-8 border-b'>
        <h2 className='text-2xl font-bold'>About</h2>
        <p data-cy='author-profile-bio' className='mt-4 whitespace-break-spaces'>
          {author.bio}
        </p>
      </div>

      {author?.expertise?.areas && (
        <div className='py-8 border-b'>
          <h2 className='text-2xl font-bold'>Areas of Expertise</h2>
          <ul className='grid grid-cols-2 gap-2'>
            {author.expertise.areas.map((industry: string, index: number) => (
              <li key={index} className='list-disc list-inside'>
                {industry}
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default AuthorBio;
